import { FeatureFlagTabs } from '@shared/guards/basic-redirect-to-next-tab.guard';

import { ROUTING_PATH } from '../routingPath';

export const SETTINGS_ROUTES_FEATURE_FLAGS: FeatureFlagTabs = {
  [`${ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.INDEX}/${ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.EXPENSE_DEFAULTS}`]:
    'expense_defaults',
  [`${ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.INDEX}/${ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.JE_CONFIGURATION}`]:
    'settings_journal_entry_configuration',
  [ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.INDEX]: 'close_settings',
  [ROUTING_PATH.SETTINGS.EXCHANGE_RATES]: 'tab_exchange_rates',
  [ROUTING_PATH.SETTINGS.INTEGRATIONS]: 'tab_integrations',
  [ROUTING_PATH.SETTINGS.INVESTIGATOR_SETTINGS]: 'tab_investigator_settings',
  [ROUTING_PATH.SETTINGS.STUDY_SPECIFICATIONS]: 'tab_forecast_studyspecifications',
  [ROUTING_PATH.SETTINGS.USER_PERMISSIONS]: 'tab_user_permissions',
  [ROUTING_PATH.SETTINGS.USERS]: null,
};
